import React, { useMemo } from 'react';
import { useRouter } from 'next/router';
import { I as Item } from './Item-Z13RNFMm.js';
import { g as SHIPPING_RETURNS, h as PRIVACY_POLICY, i as TERMS_OF_USE, T as TERMS_AND_CONDITIONS, j as CONTACT_US } from './paths-ZKN3m62_.js';
import { a as LanguageCode } from './language-BHHwgtQp.js';

// Default URL's for the Help Navigation component
// For most sites, this should be overwritten by passing 'getLocalNavigationItems' as a prop to the Help component
const getNavigationItems = (locale) => [
    {
        tabName: 'shipping-returns',
        title: '$common.$labels.shippingAndReturns',
        url: `/${locale}${SHIPPING_RETURNS}`,
        iconClassName: 'icon-truck',
    },
    {
        tabName: 'privacy-policy',
        title: '$common.$labels.privacyPolicy',
        url: `/${locale}${PRIVACY_POLICY}`,
        iconClassName: 'icon-padlock',
    },
    {
        tabName: 'terms-of-use',
        title: '$common.$labels.termsAndConditions',
        url: `/${locale}${TERMS_OF_USE}`,
        iconClassName: 'icon-gavel',
    },
    {
        tabName: 'terms-and-conditions',
        title: '$common.$labels.generalSalesConditions',
        url: `/${locale}${TERMS_AND_CONDITIONS}`,
        iconClassName: 'icon-scroll',
    },
    {
        tabName: 'contact-us',
        title: '$common.$labels.contactUs',
        url: `/${locale}${CONTACT_US}`,
        iconClassName: 'icon-envelope',
    },
];

const Navigation = ({ getLocalNavigationItems }) => {
    const { pathname } = useRouter();
    const formattedPathName = useMemo(() => pathname.split('/').pop(), [pathname]);
    const router = useRouter();
    const locale = (router === null || router === void 0 ? void 0 : router.locale) ? router.locale : LanguageCode.En;
    return (React.createElement("div", { className: "support-menu" },
        getLocalNavigationItems &&
            getLocalNavigationItems(locale).map(({ tabName, title, url, iconClassName }) => {
                const isInternalLink = typeof url === 'string';
                const urlString = isInternalLink ? url : url[locale];
                return (React.createElement(Item, { key: urlString, pathName: formattedPathName, tabName: tabName, title: title, url: urlString, iconClassName: iconClassName, target: isInternalLink ? null : '_blank' }));
            }),
        !getLocalNavigationItems &&
            getNavigationItems(locale).map(({ tabName, title, url, iconClassName }) => {
                const isInternalLink = typeof url === 'string';
                const urlString = isInternalLink ? url : url[locale];
                return (React.createElement(Item, { key: urlString, pathName: formattedPathName, tabName: tabName, title: title, url: urlString, iconClassName: iconClassName, target: isInternalLink ? null : '_blank' }));
            })));
};

export { Navigation as N };
//# sourceMappingURL=Navigation-yXC39IfA.js.map
